import React, { useState } from "react";

export default function HandMapper() {
  const [points, setPoints] = useState(() => {
    const saved = localStorage.getItem("handPositions");
    return saved ? JSON.parse(saved) : [];
  });

  const handleClick = (e) => {
    const rect = e.target.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const newPoints = [...points, { x, y }];
    setPoints(newPoints);
    localStorage.setItem("handPositions", JSON.stringify(newPoints));
    console.log("Saved point:", { x, y });
  };

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <h3>🖱 Click kids' hands to capture coordinates (auto-saved)</h3>

      {/* Background image */}
      <div
        onClick={handleClick}
        style={{
          backgroundImage: "url('/assets/person14.png')", // your kids+grass image
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "bottom",
          width: "100%",
          height: "600px",
          cursor: "crosshair",
          position: "relative",
        }}
      >
        {/* Show clicked points */}
        {points.map((p, i) => (
          <div
            key={i}
            style={{
              position: "absolute",
              left: p.x - 5,
              top: p.y - 5,
              width: 10,
              height: 10,
              borderRadius: "50%",
              backgroundColor: "red",
            }}
          ></div>
        ))}
      </div>

      <h4>📌 Saved Hand Positions:</h4>
      <pre style={{ background: "#f4f4f4", padding: "10px" }}>
        {JSON.stringify(points, null, 2)}
      </pre>
    </div>
  );
}
